module.exports = __webpack_public_path__ + "static/media/reports_kyc_status.ef803e1f.svg";